import { render } from "./SetPlayersStart.vue?vue&type=template&id=64458133&scoped=true"
import script from "./SetPlayersStart.vue?vue&type=script&lang=js"
export * from "./SetPlayersStart.vue?vue&type=script&lang=js"

import "./SetPlayersStart.vue?vue&type=style&index=0&id=64458133&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64458133"]])

export default __exports__